import { FC, ReactNode } from 'react';
import {
	DashboardCard,
	DealerCard,
	Label,
	Logo,
	LogoContainer,
	Name,
	Offers,
	Quantity,
	SubLabel,
} from './HighlightCard.styles';
import { handleKeyDown, imagesBaseUrl } from '../../utils';
import { string } from 'prop-types';

type HighlightCardProps = HightlightDefaultProps | HighlightDashboardProps | HighlightDealerProps;

interface HightlightDefaultProps {
	variant: 'default';
	children: ReactNode;
	onClick?: () => void;
}

interface HighlightDashboardProps {
	variant: 'dashboard';
	active?: boolean;
	label: string;
	sublabel?: string;
	quantity: number | string;
	onClick?: () => void;
}

interface HighlightDealerProps {
	variant: 'dealer';
	active?: boolean;
	dealerName: string;
	logoUrl?: string;
	quantity?: number;
	onClick: () => void;
	dealerId?:any;      
	dealerLogo?:any
}

const HighlightCard: FC<HighlightCardProps> = ({ variant, onClick, ...rest }) => {
	if (variant === 'dashboard') {
		const { label, quantity, active, sublabel } = rest as HighlightDashboardProps;

		return (
			<DashboardCard
				onClick={onClick}
				onKeyDown={handleKeyDown(onClick)}
				tabIndex={0}
				$active={active}
			>
				<Quantity>{quantity}</Quantity>
				<Label>{label}</Label>
				{sublabel && (<SubLabel>{sublabel}</SubLabel>)}
			</DashboardCard>
		);
	}

	if (variant === 'dealer') {
		const { dealerName, logoUrl, quantity, active, dealerId, dealerLogo } = rest as HighlightDealerProps;

		return (
			<DealerCard
				onClick={onClick}
				onKeyDown={handleKeyDown(onClick)}
				tabIndex={0}
				$active={active}
			>
				{logoUrl && (
					<LogoContainer>
						<Logo onError={(e) => {
							e.currentTarget.onerror = null;
							e.currentTarget.src = `${imagesBaseUrl.concessionaria}/${dealerId}/${dealerLogo}`}} src={logoUrl} alt={dealerName} />
					</LogoContainer>
				)}
				<Name>{dealerName}</Name>
				{quantity && (
					<Offers>
						{quantity} anúncio{quantity > 1 ? 's' : ''}
					</Offers>
				)}
			</DealerCard>
		);
	}

	const { children } = rest as HightlightDefaultProps;

	return (
		<DashboardCard onClick={onClick} tabIndex={0}>
			{children}
		</DashboardCard>
	);
};

export default HighlightCard;
